export default __webpack_public_path__ + "static/media/contract_2.d60dda3d.jpg";